/*
 * @Description: 面包屑
 * @Author: Xiaochun liu
 * @Date: 2023-10-08 11:48:16
 * @LastEditors: Lxc 1533761120@qq.com
 * @LastEditTime: 2025-08-22 09:26:54
 */
const WORKBENCH = {
  name: '首页',
  path: '/workbench',
}

export function createPathMap({ isPersonal, query }) {
  const platformSearch = {
    name: 'PlatformKnowledgeSearch',
    list: [
      WORKBENCH,
      {
        name: '平台知识库',
        path: '/platform-knowledge',
      },
    ],
  }
  const list = [
    {
      name: 'ModeView',
      list: [WORKBENCH, {
        name: '提案工作台',
        path: '/productManage',
      }, {
          name: 'AI一键提案',
          path: '/inspiration/mode',
        }],
    },
    {
      name: 'DesignView',
      list: [WORKBENCH, {
        name: '数智灵感箱',
        path: '/inspiration/design',
      }],
    },
    {
      name: 'ProductDetailView',
      list: [WORKBENCH, {
        name: '提案工作台',
        path: '/productManage',
      }, {
          name: '提案详情',
          path: '/productDetail',
        }],
    },
    {
      name: 'ProposalDetailView',
      list: [WORKBENCH, {
        name: '提案工作台',
        path: '/productManage',
      }, {
          name: '提案详情',
          path: '/proposalDetail',
        }],
    },
    {
      name: 'ProductInformationView',
      list: [WORKBENCH, {
        name: '提案工作台',
        path: '/productManage',
      }, {
          name: '提案详情',
          path: '/productInformation',
        }],
    },
    {
      name: 'ProductIntelligenceView',
      list: [WORKBENCH, {
        name: '提案工作台',
        path: '/productManage',
      }, {
          name: '提案详情',
          path: '/productIntelligence',
        }],
    },
    {
      name: 'ProductDynamicView',
      list: [WORKBENCH, {
        name: '提案工作台',
        path: '/productManage',
      }, {
          name: '提案详情',
          path: '/productDynamic',
        }],
    },
    {
      name: 'CreateProductView',
      list: [WORKBENCH,
        {
          name: '提案工作台',
          path: '/productManage',
        }, {
          name: '编辑方案',
          path: '/createProduct',
        }],
    },
    {
      name: 'ProposalView',
      list: [WORKBENCH,
        {
          name: '提案工作台',
          path: '/proposal',
        }],
    },
    {
      name: 'SelectProductView',
      list: [WORKBENCH, {
        name: '方案验证',
        path: '/selectProduct',
      }],
    },
    // {
    //   name: 'ProductManageView',
    //   list: [WORKBENCH, {
    //     name: '提案工作台',
    //     path: '/productManage',
    //   }],
    // },
    {
      name: 'IntelligenceCenter',
      list: [WORKBENCH,
        {
          name: '情报中心',
          path: '/intelligence',
        }],
    },
    {
      name: 'IntelligenceMarketDetail',
      list: [WORKBENCH,
        {
          name: '情报中心',
          path: '/intelligence',
        }, {
          name: '市场风向详情',
          path: '/intelligence/market',
        }],
    },
    {
      name: 'IntelligenceTechnologyDetail',
      list: [WORKBENCH,
        {
          name: '情报中心',
          path: '/intelligence',
        }, {
          name: '前沿科技详情',
          path: '/intelligence/technology',
        }],
    },
    // {
    //   name: 'SelectKnowledgeView',
    //   list: [WORKBENCH,
    //     {
    //       name: '数智沙盘',
    //       path: '/selectProduct',
    //     }, {
    //       name: '选择知识库',
    //       path: '/selectKnowledge/:id',
    //     }],
    // },
    // {
    //   name: 'ValidateResultView',
    //   list: [WORKBENCH,
    //     {
    //       name: '数智沙盘',
    //       path: '/selectProduct',
    //     }, {
    //       name: '选择知识库',
    //       path: '/selectKnowledge/:id',
    //     }, {
    //       name: '提案验证',
    //       path: '/validateResult',
    //     }],
    // },
    {
      name: 'PersonalCenterView',
      list: [WORKBENCH, {
        name: '个人中心',
        path: '/personalCenter',
      }],
    },
    {
      name: 'KnowledgeBaseView',
      list: [WORKBENCH, {
        name: '知识库',
        path: '/knowledgeBase',
      }],
    },
    {
      name: 'KnowledgeFileView',
      list: [WORKBENCH, {
        name: '知识库',
        path: '/knowledgeBase',
      }],
    },
    {
      name: 'KnowledgeInFolderiew',
      list: [WORKBENCH, {
        name: '知识库',
        path: '/knowledgeBase',
      }],
    },
    {
      name: 'KnowledgeFolderiew',
      list: [WORKBENCH, {
        name: '知识库',
        path: '/knowledgeBase',
      }],
    },
    {
      name: 'KnowledgeFileDetail',
      list: [WORKBENCH, {
        name: '知识库',
        path: '/knowledgeBase',
      }],
    },
    {
      name: 'PersonalCenterBasicInfoView',
      list: [WORKBENCH, {
        name: '个人中心',
        path: '/personal-center/basic-info',
      }],
    },
    {
      name: 'PersonalCenterEnergyPointInfoView',
      list: [WORKBENCH, {
        name: '个人中心',
        path: '/personal-center/energy-point-info',
      }],
    },
    {
      name: 'PersonalCenterExchangeEnergyPointView',
      list: [WORKBENCH, {
        name: '个人中心',
        path: '/personal-center/exchange-energy-point',
      }],
    },
    {
      name: 'PersonalCenterCompanyManagementView',
      list: [WORKBENCH, {
        name: '个人中心',
        path: '/personal-center/company-management',
      }],
    },
    {
      name: 'PersonalCenterCompanyProductMembersView',
      list: [WORKBENCH, {
        name: '个人中心',
        path: '/personal-center/company-product-member/:id',
      }],
    },
    {
      name: 'NotifyView',
      list: [WORKBENCH, {
        name: '消息列表',
        path: '/notify',
      }],
    },
    {
      name: 'ProductProcessSolutionIntroduction',
      list: [WORKBENCH, {
        name: '产品全流程解决方案',
        path: '/introdution/product-process-solution',
      }],
    },
    {
      name: 'InspirationLibrary',
      list: [WORKBENCH, {
        name: isPersonal ? '灵感库' : '企业灵感库',
        path: '/inspiration-library',
      }],
    },
    {
      name: 'InspirationLibraryDetail',
      list: [WORKBENCH, {
        name: isPersonal ? '灵感库' : '企业灵感库',
        path: '/inspiration-library',
      }, {
          name: '灵感详情',
        }],
    },
    // {
    //   name: 'Knowledge',
    //   list: [WORKBENCH, {
    //     name: isPersonal ? '个人知识库' : '企业知识库',
    //     path: '/knowledge',
    //   }],
    // },
    // {
    //   name: 'PlatformKnowledge',
    //   list: [
    //     WORKBENCH,
    //     {
    //       name: '平台知识库',
    //       path: '/platform-knowledge',
    //     }
    //   ],
    // }
    {
      name: 'CustomerProposalArchive',
      list: [WORKBENCH, {
        name: '客户提案Agent',
        path: '/customer-proposal-agent',
      }, {
          name: '企业基础资料',
        }],
    },
    {
      name: 'MarketAgentAnalysis',
      list: [WORKBENCH, {
        name: '市场调研Agent',
        path: '/market-agent',
      }, {
          name: '回答详情',
        }],
    },
  ]

  return [
    ...list,
    platformSearch,
  ]
}
